<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-11-11 11:03:38
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-02 11:11:40
-->
<template>
  <div>
    <div class="head">
      <div style="display: flex; align-items: center">
        <div class="back" @click="toBack"><a-icon type="arrow-left" /></div>
        <div
          style="
            font-size: 18px;
            color: #303133;
            font-weight: bold;
            margin-left: 12px;
          "
        >
          禁言名单
        </div>
      </div>
    </div>
    <coententTable
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :pagination="pagination"
      :dataSource="dataSource"
      :customSlot="customSlot"
      :loading="listLoading"
      :y="height"
      @handleSizeChange="handleSizeChange"
    >
      <template v-slot:logo="scopeVal">
        <a-popover trigger="click">
          <div class="content" slot="content">
            <div style="font-size: 16px; margin-bottom: 10px">操作信息</div>
            <div
              class="open-style"
              v-for="(item, index) in seeData"
              :key="index"
            >
              <div>操作人: {{ item.managementName || "--" }}</div>
              <div>操作时间: {{ item.operateTime || "--" }}</div>
            </div>
          </div>
          <a  v-if="codeData.indexOf('195') != -1" @click="seeLogo(scopeVal.scope.id)">查看</a>
        </a-popover>
      </template>
      <template v-slot:isLogin="scopeVal">
        <div>
          {{ scopeVal.scope.isLogin ? "是" : "否" }}
        </div>
      </template>
      <template v-slot:operation="scopeVal">
        <div v-if="codeData.indexOf('196') != -1" style="width:66px" @click="toTaboo(scopeVal.scope)" class="btnTwo">解除禁言</div>
      </template>
    </coententTable>
  </div>
</template>

<script>
import { chatRoomList, findChatLogList,updateTaboo } from "./online_interview";
import coententTable from "@/components/coentent_table.vue";
export default {
  data() {
    return {
      height: 0,
      columns: [
        {
          title: "网友名称",
          dataIndex: "userName",
          ellipsis: true,
          width: 120,
        },
        {
          title: "IP地址",
          dataIndex: "ipAddress",
          ellipsis: true,
          width: 200,
        },
        {
          title: "是否登录",
          dataIndex: "isLogin",
          scopedSlots: { customRender: "isLogin" },
          ellipsis: true,
          width: 120,
        },
        {
          title: "留言时间",
          dataIndex: "messageTime",
          ellipsis: true,
          width: 200,
        },
        {
          title: "留言内容",
          dataIndex: "messageContents",
          ellipsis: true,
          width: 400,
          customCell: column => {
                        return {
                        style: {
                            'min-width': "320px",
                            'max-width': "400px",
                        }
                    };
                    },
                    customHeaderCell: column => {
                    return {
                        style: {
                            'min-width': "320px",
                            'max-width': "400px",
                        }
                    };
                    }
        },
        {
          title: "操作信息",
          dataIndex: "logo",
          scopedSlots: { customRender: "logo" },
           ellipsis: true,
          width: 120,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 150,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
      dataSource: [],
      customSlot: [
        {
          name: "isLogin",
          customRender: "isLogin",
        },
        {
          name: "logo",
          customRender: "logo",
        },
      ],
      listLoading: false,
      seeData: {},
      codeData:[],
    };
  },
  components: {
    coententTable,
  },
  mounted() {
    this.getChatList();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    toBack() {
      this.$router.push({
        path: "/index/interaction/online_interview",
      });
    },
    seeLogo(id) {
      findChatLogList({ id: id }).then((res) => {
        if (res.code == 0) {
          this.seeData = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getChatList();
    },
    handleSizeChange(pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.getChatList();
    },
    toTaboo(item) {
        updateTaboo({
            id:item.id,
            taboo:0,
        }).then((res)=>{
            if(res.code == 0){
                this.getChatList();
            }
        })
    },
    getChatList() {
      this.listLoading = true;
      chatRoomList({
        current: this.pagination.current,
        taboo: 2,
        size: this.pagination.pageSize,
      }).then((res) => {
        if (res.code == 0) {
          this.dataSource = res.data.records;
          this.pagination.current = res.data.current;
          this.pagination.total = res.data.total;
          this.pagination.pageSize = res.data.size;
          this.listLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dcdfe6;
  padding: 18px 24px;
}
.back{
  cursor: pointer;
}
 .btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>    